import {
  NOTIFICATION_FACE_ORIENT_WARNING,
  NOTIFICATION_FACE_SIZE_WARNING,
  NOTIFICATION_INTERFERENCE_WARNING,
  NOTIFICATION_LOW_FPS_WARNING,
  WARNING_ERROR_LOADING,
  WARNING_NO_FACE_DETECTED,
  WARNING_NO_LIVELINESS_DETECTED,
} from '../../pages/vital-checker/consts';

export const vitals = {
  healthyReading: 'No abnormalities detected!',
  unhealthyReading: 'Your vitals may be out of normal range.',
  errorReading: 'Unable to check your vitals, please try again.',
  keepFaceInside: 'Please keep your face inside the circle...',
  stress: 'Stress',
  heartRate: 'Heart rate',
  oxygen: 'Oxygen',
  bloodPressure: 'Blood pressure',
  respiratoryRate: 'Respiratory rate',
  recordedOnToday: 'Recorded on today at {{ time }}',
  recordedOn: 'Recorded on {{ time }}',
  disclaimerTitle: 'Vitals checker disclaimer',
  scanning: 'Scanning in progress',
  pleaseEnsureYourFace: 'Please ensure your face takes up most of the camera view',
  pleaseKeepStill: 'Please keep still',
  needAssistance: 'Need assistance?',
  feelFreeToContactPrime: 'Feel free to contact your Prime Team!',
  disclaimer1:
    'This technology isn’t a medical device. It’s meant to help you be more aware of your health and wellness. We don’t claim to diagnose, minimize, prevent, or treat any diseases, disorders, symptoms, or unusual physical states.',
  disclaimer2:
    'This tool is for screening purposes only and should not replace in-person vital signs or examinations when necessary.',
  history: 'History',
  whoUsingScanner: 'Who is using the scanner today?',
  actions: {
    moreOptions: 'More options',
    finish: 'Finish & return Home',
    checkAgain: 'Check Again',
    viewHistory: 'View History',
    checkMySymptoms: 'Check my symptoms',
    contactForSupport: 'Contact for support',
    cancel: 'Cancel',
    moreInfoAccuracy: 'More information on the vital checker’s accuracy',
    callUs: 'Call Us',
  },
  vastmindz: {
    notifications: {
      [NOTIFICATION_LOW_FPS_WARNING]: 'Low FPS warning',
      [NOTIFICATION_INTERFERENCE_WARNING]: 'Bad reading, please try again in better conditions',
      [NOTIFICATION_FACE_ORIENT_WARNING]: 'Please look straight ahead',
      [NOTIFICATION_FACE_SIZE_WARNING]: 'Please move closer to the camera',
    },
    warnings: {
      [WARNING_ERROR_LOADING]: 'Error loading. Try to refresh the page',
      [WARNING_NO_FACE_DETECTED]: 'No face detected',
      [WARNING_NO_LIVELINESS_DETECTED]: 'No liveliness detected',
    },
    buttonValue: {
      INIT: 'Loading',
      START: 'Take test',
      STOP: 'Stop',
    },
    signalStatus: {
      WEAK_SIGNAL: 'Weak signal quality',
      INITIALIZING: 'Initializing...',
      MEASURING: 'Measuring..',
    },
    bpm: 'Heart Rate',
    rr: 'Breathing rate',
    oxygen: 'Blood oxygen',
    stressStatus: 'Stress',
    bloodPressureStatus: 'Blood Pressure',
    description1: 'Please keep your face in the oval',
    description2: 'Ensure your face is well lit',
    description3: 'Ensure your device is held steady',
    status: 'Status',
  },
};
